/**
 * Hour tag presets — whole days only. The rule form derives its preset from
 * the picked dates, so a rolling preset (last-48-hours = yesterday → today)
 * is saved as the same whole days under "custom".
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  HOUR_TAG_DEFAULT_MIN_VOLUME,
  HOUR_TAG_EXCLUDED_PRESETS,
  HOUR_TAG_MIN_VOLUME_MAX,
} from '@trafficpulse/shared';

export const HOUR_EXCLUDED_PRESETS: readonly string[] = HOUR_TAG_EXCLUDED_PRESETS;
export const HOUR_DEFAULT_MIN_VOLUME = HOUR_TAG_DEFAULT_MIN_VOLUME;
export const HOUR_MIN_VOLUME_MAX = HOUR_TAG_MIN_VOLUME_MAX;

export const isHourExcludedPreset = (preset: string): boolean =>
  HOUR_EXCLUDED_PRESETS.includes(preset);

export function toHourPreset<P extends string>(preset: P): P | 'custom' {
  return isHourExcludedPreset(preset) ? 'custom' : preset;
}

/** A whole number 0..1,000,000, or null when the input is not one. */
export function parseMinVolume(raw: unknown): number | null {
  const n = typeof raw === 'string' && raw.trim() !== '' ? Number(raw) : raw;
  return typeof n === 'number' && Number.isInteger(n) && n >= 0 && n <= HOUR_MIN_VOLUME_MAX
    ? n
    : null;
}
